import { __assign } from "tslib";
import * as React from 'react';
import { Anchor } from '../../components/Anchor/index.js';
export var FooterLink = function (props) { return (React.createElement("li", null,
    React.createElement(Anchor, __assign({}, props, { className: "h3" })))); };
//# sourceMappingURL=FooterLink.js.map